import { render, staticRenderFns } from "./PhysicianPopups.vue?vue&type=template&id=531e74cd&scoped=true&"
import script from "./PhysicianPopups.vue?vue&type=script&lang=js&"
export * from "./PhysicianPopups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531e74cd",
  null
  
)

export default component.exports